import type { Observable } from 'rxjs';
import type { MarketDataSnapshot } from '../../types/MarketDataSnapshot';
import type { OHLCData } from '../../types/OHLCData';
import type { ResolutionEnumNoPrefix } from '../../types/OrderAnalytic';
import type { Security } from '../../types/Security';
import { SmartTruncateEnum } from '../FormattedNumber';
import { MarketView } from './MarketView';
import type { ClickRowCallback } from './types';
import { VolumeLadderSteps } from './VolumeLadderSteps';

export const HEIGHT_LIMIT = 381;
const LADDER_TOP_HEIGHT = 194;

interface VolumeLadderContentProps {
  resolution: ResolutionEnumNoPrefix;
  onClickRow: ClickRowCallback;
  security?: Security;
  marketViewObservable: Observable<MarketDataSnapshot>;
  sparklineDataObservable: Observable<OHLCData[]>;
  marketDataObservable: Observable<MarketDataSnapshot>;
  showSpread?: boolean;
  sizeBuckets: string[];
  smartTruncate?: SmartTruncateEnum;
  size: { offsetWidth?: number; offsetHeight?: number };
  bpsIncrement?: string;
  usePreciseTopOfBookIncrement?: boolean;
}

export const VolumeLadderContent = ({
  resolution,
  onClickRow,
  security,
  marketViewObservable,
  sparklineDataObservable,
  marketDataObservable,
  showSpread,
  sizeBuckets,
  smartTruncate = SmartTruncateEnum.None,
  size,
  bpsIncrement,
  usePreciseTopOfBookIncrement,
}: VolumeLadderContentProps) => {
  return (
    <>
      <MarketView
        resolution={resolution}
        onClickRow={onClickRow}
        security={security}
        marketDataObservable={marketViewObservable}
        sparklineDataObservable={sparklineDataObservable}
        showSpread={showSpread}
        bpsIncrement={bpsIncrement}
        width={size.offsetWidth}
        usePreciseTopOfBookIncrement={usePreciseTopOfBookIncrement}
      />
      {size.offsetHeight && size.offsetHeight > HEIGHT_LIMIT / 2 && (
        <VolumeLadderSteps
          sizeBuckets={sizeBuckets}
          marketDataObservable={marketDataObservable}
          security={security}
          onClickRow={onClickRow}
          showSpread={showSpread}
          smartTruncate={smartTruncate}
          width={size.offsetWidth}
          height={size.offsetHeight - LADDER_TOP_HEIGHT}
          bpsIncrement={bpsIncrement}
        />
      )}
    </>
  );
};
